import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import Loading from '@/component/loading';
import oyaRoutes from './route';

const OyaApp = () => {
  const element = useRoutes(oyaRoutes);
  return <Suspense fallback={<Loading />}>{element}</Suspense>;
};

export default OyaApp;
